import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const hasMaxAmountOfTrezorAccountsSelectorFactory = ({ maxAmountOfAccounts = 3 }) => (filter) => createSelector(filter({ enabled: true, trezor: true }), (currentAccounts) => currentAccounts.length >= maxAmountOfAccounts);
const createHasMaxAmountOfAccountsSelectorDefinition = (config) => defineSelectorFactory({
    id: 'hasMaxAmountOfTrezorAccounts',
    selectorFactory: hasMaxAmountOfTrezorAccountsSelectorFactory(config),
    dependencies: [
        { selector: 'filter' },
    ],
});
export default createHasMaxAmountOfAccountsSelectorDefinition;
